import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { NbTokenService } from '@nebular/auth';
import { NbToastrService } from '@nebular/theme';
import { saveAs } from 'file-saver/src/FileSaver';
import { CookieService } from 'ngx-cookie-service';
import { format } from 'support';

import { UsersService } from 'app/@core/backend/common/services/users.service';
import {
  FitnessPlan,
  FitnessPlanData,
  MealPlan,
  MealPlanData,
} from 'app/@core/interfaces/common/CalorieFriend/plan';
import {
  Patient,
  PatientData,
} from 'app/@core/interfaces/common/CalorieFriend/patients';
import { GridData } from 'app/@core/interfaces/common/grid-data';
import { PatientStore } from 'app/@core/stores/patient.store';
import { replaceRootStyle } from 'app/@core/utils/themes';
import { NativeAppService } from 'app/@core/backend/common/services/native-app.service';
import { UserStore } from 'app/@core/stores/user.store';
import { ChatService } from 'app/@chat/chat.service';
import { IChatThread } from 'app/@chat/domain';

export class PlanInfo {
  planName: string;
  planUrl: string;
  active: boolean;
  planType: string;
}

@Component({
  selector: 'ngx-frontends',
  styleUrls: ['frontends.component.scss'],
  templateUrl: './frontends.component.html',
})
export class FrontendsComponent implements OnInit, AfterViewInit, OnDestroy {
  logo: string = '';

  alive: boolean = true;

  isExpanded = false;

  NotificationToken: string = null;
  PatientID = null;
  PlanID = null;
  private patient: Patient;
  private isFitnessPlan: boolean = false;

  ThePlan: any;
  plans: Array<MealPlan> = null;

  showProgram: boolean = false;

  FitnessPlans: Array<FitnessPlan> = null;

  ShowEmailSubmit: boolean = false;
  HidePatientInfo: boolean = false;

  ProblemGenertingPDF =
    'Problem occurre generating PDF Report. Try again. If problem continues contact support.';

  PlanListSource: Observable<GridData<MealPlan>> = null;
  protected readonly unsubscribe$ = new Subject<void>();

  FitnessPlanListSource: Observable<GridData<FitnessPlan>> = null;

  planIdCookieName = 'last-plan-id';
  planTypeCookieName = 'last-plan-type';

  indexPageUrl = '';

  ProblemSendingToPatient = 'Problem sending patient view to patient.';
  SuccessSendingToPatient = 'Sent email to patient.';

  threadSubject: BehaviorSubject<IChatThread> =
    new BehaviorSubject<IChatThread>(null);
  unSeenMessages: Observable<number>;
  showChatWindow = false;

  constructor(
    private tokenService: NbTokenService,
    private PlanViewUsersService: UsersService,
    private planService: MealPlanData,
    private fitnessPlanService: FitnessPlanData,
    private toasterService: NbToastrService,
    private router: Router,
    private cookieService: CookieService,
    private PlanViewPlanService: MealPlanData,
    private PlanViewToasterService: NbToastrService,
    private patientData: PatientData,
    private patientStore: PatientStore,
    private nativeAppService: NativeAppService,
    private userStore: UserStore,
    private chatService: ChatService
  ) {
    this.tokenService
      .tokenChange()
      .pipe(takeWhile(() => this.alive))
      .subscribe(() => {});
  }

  convertWindowInnerHeightToLvh() {
    // (document.getElementsByClassName('scrollable-container')[0] as any).style.height = window.innerHeight + 'px';
    (document.getElementsByClassName('scrollable-container')[0] as any).style.paddingTop = '75px';

  }
  // set resize using hostlistener
  // @HostListener('window:resize', ['$event'])
  // onResize(event) {
  //   this.convertWindowInnerHeightToLvh();
  // }

  private getActivatedRoute(): ActivatedRoute {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  ngOnInit() {
    const route = this.getActivatedRoute();
    // this.convertWindowInnerHeightToLvh();
    if (!this.PatientID)
      this.PatientID = route.snapshot.paramMap.get('PatientId');

    if (!this.PatientID)
      this.NotificationToken = route.snapshot.paramMap.get('NotificationToken');

    if (!this.NotificationToken)
      this.NotificationToken = route.snapshot.paramMap.get('patientGuid');

    this.patientData
      .getSettings(this.PatientID, this.NotificationToken)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (settings) => {
          this.patientStore.setSettings(settings);
          this.logo = settings.logo ?? 'assets/images/logo.png';
          replaceRootStyle(document, settings.color);
          console.log("Applying Settings")
          this.nativeAppService.sendJavascriptMessageToApp(
            'Settings',
            settings
          );
        },
        (err) => {
          this.logo = 'assets/images/logo.png';
        }
      );

    this.patientData.get(null, this.NotificationToken).subscribe(
      (patient) => {
        this.patient = patient;

        this.patientStore.setPatient(patient);
        if (patient.isArchived) {
          this.router.navigateByUrl(
            `/PatientView/Invalid/${this.NotificationToken}`
          );
        }
        if (
          (patient.mealProgramMode && patient.mealProgramMode > 0) ||
          (patient.fitnessProgramMode && patient.fitnessProgramMode > 0)
        ) {
          this.showProgram = true;

          this.nativeAppService.sendJavascriptMessageToApp(
            'hasProgramMode',
            'true'
          );
          1;
        } else {
          this.nativeAppService.sendJavascriptMessageToApp(
            'hasProgramMode',
            'false'
          );
        }

        /**
         * Chat config
         */
        const chatUser = {
          id: this.patient.id,
          name: this.patient.name,
          uid: `p_${this.patient.id}`,
        };
        const coachUser = {
          id: this.patient.createdByUserId,
          name: `${this.patient.createdByUser?.firstName} ${this.patient.createdByUser?.lastName}`,
          uid: `u_${this.patient.createdByUserId}`,
        };
        this.chatService.connect(chatUser, true);

        setInterval(() => {
          this.chatService.reconnect();
        }, 1000 * 5);
        const chatThread = {
          id: coachUser.id,
          name: coachUser.name,
          users: [coachUser],
        };
        this.chatService.registerThreads([chatThread]);
        this.threadSubject.next(chatThread);
        this.unSeenMessages = this.chatService.totalUnseenCount;
      },
      () => {
        this.router.navigateByUrl(
          `/PatientView/Invalid/${this.NotificationToken}`
        );
      }
    );

    // decide if this is fitness plan
    if (
      route.snapshot.url.length >= 3 &&
      route.snapshot.url[2].path === 'Workout'
    )
      this.isFitnessPlan = true;
    else this.isFitnessPlan = false;

    // url section
    if (!this.PlanID || this.PlanID === undefined)
      this.PlanID = route.snapshot.paramMap.get('PlanId');

    // url query string
    if (!this.PlanID || this.PlanID === undefined)
      this.PlanID = route.snapshot.queryParams.PlanId;

    // from cookie
    if (!this.PlanID || this.PlanID === undefined) {
      this.PlanID = this.cookieService.get(this.planIdCookieName);
      this.isFitnessPlan =
        this.cookieService.get(this.planTypeCookieName) === 'Workout';
    }

    this.PlanListSource = this.planService.listByGuid(this.NotificationToken);

    this.PlanListSource.subscribe((data) => {
      this.plans = data.items;

      // active plan id
      if (!this.isFitnessPlan && (!this.PlanID || this.PlanID === undefined)) {
        const activePlan = this.plans.find((plan) => plan.active);
        if (activePlan) {
          this.PlanID = activePlan.id;
        }
      }

      if (!this.isFitnessPlan && (!this.PlanID || this.PlanID === undefined)) {
        if (this.plans.length > 0) {
          this.plans.sort((p1, p2) => p2.id - p1.id);
          this.PlanID = this.plans[0].id;
        }
      }

      this.indexPageUrl = `/PatientView/Patient/${this.NotificationToken}`;

      if (!this.isFitnessPlan && this.PlanID) {
        this.cookieService.set(this.planIdCookieName, this.PlanID, 0, '/');
        this.cookieService.set(this.planTypeCookieName, 'Meal', 0, '/');
        this.indexPageUrl += `/Meal/${this.PlanID}`;
      }

      if (
        !this.isFitnessPlan &&
        route.snapshot.url.length > 0 &&
        route.snapshot.url[0].path === 'Patient'
      ) {
        if (
          this.plans !== null &&
          this.plans !== undefined &&
          this.plans.length > 0
        ) {
          if (this.PlanID !== null && this.PlanID !== undefined) {
            this.ThePlan = this.plans.find((plan) => plan.id === +this.PlanID);
          } else this.ThePlan = this.plans[0];
        }
      }

      const mealPlanInfo: Array<PlanInfo> = new Array<PlanInfo>();
      this.plans.forEach((value) => {
        const plan = new PlanInfo();
        plan.active = value.active;
        plan.planName = value.name;
        plan.planType = 'mealplan';
        plan.planUrl = `/PatientView/Patient/${this.NotificationToken}/Meal/${value.id}`;
        mealPlanInfo.push(plan);
      });
      this.nativeAppService.sendJavascriptMessageToApp(
        'MealPlans',
        mealPlanInfo
      );
    });

    this.FitnessPlanListSource = this.fitnessPlanService.listByGuid(
      this.NotificationToken
    );

    this.FitnessPlanListSource.subscribe((data) => {
      this.FitnessPlans = data.items;

      // active plan id
      if (this.isFitnessPlan && (!this.PlanID || this.PlanID === undefined)) {
        const activePlan = this.FitnessPlans.find((plan) => plan.active);
        if (activePlan) {
          this.PlanID = activePlan.id;
        }
      }

      if (this.isFitnessPlan && (!this.PlanID || this.PlanID === undefined)) {
        if (this.FitnessPlans.length > 0) {
          this.FitnessPlans.sort((p1, p2) => p2.id - p1.id);
          this.PlanID = this.FitnessPlans[0].id;
        }
      }

      if (this.isFitnessPlan && this.PlanID) {
        this.indexPageUrl = `/PatientView/Patient/${this.NotificationToken}`;
        this.cookieService.set(this.planIdCookieName, this.PlanID, 0, '/');
        this.cookieService.set(this.planTypeCookieName, 'Workout', 0, '/');
        this.indexPageUrl += `/Workout/${this.PlanID}`;
      }

      if (
        this.isFitnessPlan &&
        route.snapshot.url.length > 0 &&
        route.snapshot.url[0].path === 'Patient'
      ) {
        if (
          this.FitnessPlans !== null &&
          this.FitnessPlans !== undefined &&
          this.FitnessPlans.length > 0
        ) {
          if (this.PlanID !== null && this.PlanID !== undefined) {
            this.ThePlan = this.FitnessPlans.find(
              (plan) => plan.id === +this.PlanID
            );
          } else {
            this.ThePlan = this.FitnessPlans[0];
          }
        }
      }

      const fitnessPlanInfo: Array<PlanInfo> = new Array<PlanInfo>();
      this.FitnessPlans.forEach((value) => {
        const plan = new PlanInfo();
        plan.active = value.active;
        plan.planName = value.name;
        plan.planType = 'fitnessplan';
        plan.planUrl = `/PatientView/Patient/${this.NotificationToken}/Workout/${value.id}`;
        fitnessPlanInfo.push(plan);
      });
      this.nativeAppService.sendJavascriptMessageToApp(
        'FitnessPlans',
        fitnessPlanInfo
      );
    });
  }

  ngAfterViewInit(): void {
    if (this.patientStore.settings())
      replaceRootStyle(document, this.patientStore.settings()?.color);
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  collapse() {
    this.isExpanded = false;
  }

  PlanChanged(plan: MealPlan) {
    const isMealPlan = this.plans.findIndex((p) => p.id === plan.id) >= 0;
    const isFitnessPlan =
      this.FitnessPlans.findIndex((p) => p.id === plan.id) >= 0;

    const url = `/PatientView/Patient/${this.NotificationToken}/${
      isMealPlan ? 'Meal' : isFitnessPlan ? 'Workout' : ''
    }/${plan.id}`;
    //window.open(url, '_self');
    this.router.navigateByUrl(url);
    this.ThePlan = plan;
  }

  SendPatientView() {
    const observable = this.PlanViewPlanService.submitPatientNotificationByGuid(
      this.NotificationToken,
      this.ThePlan.id
    );

    observable.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (Data) => {
        this.PlanViewToasterService.success('', this.SuccessSendingToPatient);
      },
      (err) => {
        this.PlanViewToasterService.danger('', this.ProblemSendingToPatient);
      }
    );
  }

  SaveAsPDF() {
    let observable = null;

    if (this.NotificationToken != null && this.NotificationToken !== undefined)
      observable = this.planService.SaveAsPDFFromToken(
        this.NotificationToken,
        this.ThePlan.id
      );
    else if (this.PatientID !== null && this.PatientID !== undefined)
      observable = this.planService.SaveAsPDF(this.PatientID, this.ThePlan.id);

    if (observable != null) {
      observable.pipe(takeUntil(this.unsubscribe$)).subscribe(
        (PDFData) => {
          saveAs(PDFData, format('PatientPlan_{0}.pdf', this.ThePlan.name));
        },
        (err) => {
          this.toasterService.danger('', this.ProblemGenertingPDF);
        }
      );
    }
  }

  OpenProfile() {
    window.open(`/PatientView/GeneralInfo/${this.NotificationToken}`);
  }

  OpenWeeklyAssesment() {
    window.open(`/PatientView/PatientAssessment/${this.NotificationToken}`);
  }

  OpenGoals() {
    window.open(`/PatientView/PatientGoals/${this.NotificationToken}`);
  }

  toggleChatWindow() {
    this.showChatWindow = !this.showChatWindow;
  }
}
